import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppService } from "src/app/app.service";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: "app-edit-profile",
  templateUrl: "./edit-profile.component.html",
  styleUrls: ["./edit-profile.component.css"],
})
export class EditProfileComponent implements OnInit {
  userInfo: any;
  model: any = {};
  isLoading = false;
  btnDisable = false;
  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private service: AppService,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.route.params.subscribe((params) => {
      this.model.id = params.id;
    });
    this.service.profileDetail(this.model.id).subscribe((res: any) => {
      this.model = res.result;
      this.model.color = this.model.color ? this.model.color : "yellow";
      this.spinner.hide();
    });
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (encryptedData) {
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
          CryptoJS.enc.Utf8
        )
      );
    } else {
      this.router.navigate(["/"]);
    }
  }
  onSubmit(form: any) {
    if (form.valid) {
      this.btnDisable = true;
      this.isLoading = true;
      this.service.editProfile(this.model).subscribe(
        (res: any) => {
          this.btnDisable = false;
          this.isLoading = false;
          const index = this.userInfo.people_profile
            .map((el) => {
              return el.id;
            })
            .indexOf(parseInt(this.model.id));
          if (index != -1) {
            this.userInfo.people_profile[index] = res;
            const encryptData = CryptoJS.AES.encrypt(
              JSON.stringify(this.userInfo),
              environment.secretkey
            ).toString();
            localStorage.setItem(environment.localStorageKey, encryptData);
          }

          this.toastr.success(res.message, "Success!", {
            closeButton: true,
          });
          this.router.navigate(["/manage-profile/watch"]);
        },
        (err) => {
          this.btnDisable = false;
          this.isLoading = false;
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        }
      );
    }
  }
  removeProfile() {
    Swal.fire({
      title: "Are you sure",
      text: "you want to remove profile?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.service.removeProfile(this.model.id).subscribe(
          (res: any) => {
            if (res) {
              const index = this.userInfo.people_profile
                .map((el) => {
                  return el.id;
                })
                .indexOf(parseInt(this.model.id));
              if (index != -1) {
                this.userInfo.people_profile.splice(index, 1);
                if (this.userInfo.profile_id === this.model.id) {
                  this.userInfo.profile_id =
                    this.userInfo.people_profile[0]?.id;
                }
                const encryptData = CryptoJS.AES.encrypt(
                  JSON.stringify(this.userInfo),
                  environment.secretkey
                ).toString();
                localStorage.setItem(environment.localStorageKey, encryptData);
              }
              this.toastr.success(res.message, "Success!", {
                closeButton: true,
              });
              this.router.navigate(["/manage-profile/watch"]);
            }
          },
          (err) => {
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      }
    });
  }
}
